/**
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business ops セクション内のタブナビ。demo.html の app-nav（Queue / New Request / My Requests / Assignments / SLO）を PIL の TanStack Router Link で再現し、アクティブタブをアクセントで示す
 * @graph-connects none
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';

/** タブ定義。 */
interface OpsTabDef {
  /** 遷移先ルート。 */
  to: string;
  /** 表示ラベルの翻訳キー（module scope では hook を呼べないため t() で解決する）。 */
  labelKey: string;
  /** 完全一致でのみアクティブにするか（index ルート用）。 */
  exact?: boolean;
}

/** ops セクションのタブ一覧。 @graph-connects none */
const OPS_TABS: OpsTabDef[] = [
  { to: '/ops', labelKey: 'ops.tabs.queue', exact: true },
  { to: '/ops/submit', labelKey: 'ops.tabs.newRequest' },
  { to: '/ops/my-requests', labelKey: 'ops.tabs.myRequests' },
  { to: '/ops/assignments', labelKey: 'ops.tabs.assignments' },
  { to: '/ops/dashboard', labelKey: 'ops.tabs.slo' },
];

/** ops セクション内タブナビを描画する。 @graph-connects none */
export function OpsTabs(): ReactNode {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b border-[var(--color-border)] pb-2">
      {OPS_TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          activeOptions={{ exact: tab.exact === true }}
          className="rounded-lg px-3 py-1.5 text-sm font-medium text-[var(--color-text-secondary)] transition-colors hover:bg-[var(--color-bg-hover)] hover:text-[var(--color-text-primary)]"
          activeProps={{
            className:
              'rounded-lg px-3 py-1.5 text-sm font-semibold bg-[var(--color-accent-primary)] text-white',
          }}
        >
          {t(tab.labelKey)}
        </Link>
      ))}
    </nav>
  );
}
